/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */
export var ERROR = 'invalid_email';
/**
 * Creates validator for e-mail address
 *
 * @function email
 * @return {validator} E-mail address validator
 */

export default function email() {
  return function (value) {
    if (value && !value.match(/^[\w\-]([\.\w\-])*@([\w\-]+\.)+[A-Za-z]{2,6}$/i)) return ERROR;
    return null;
  };
}